import { render } from "./EventDetails.vue?vue&type=template&id=53f28f5f"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script